<template>
  <path
    fill="currentColor"
    d="M11.975 0C5.681 0 .525 4.827 0 10.965h13.664L9.81 6.885c-.413-.386-.425-1.122 0-1.496.413-.387 1.126-.25 1.502.087l5.493 5.813c.163.175.263.462.275.711a.997.997 0 0 1-.275.711l-5.493 5.813c-.35.35-1.101.474-1.502.087-.4-.387-.338-1.147 0-1.497l3.854-4.079H0C.526 19.172 5.68 24 11.975 24 18.619 24 24 18.636 24 12.012 24 5.39 18.62.025 11.975.025V0Z"
  />
</template>
